const OPEN_POPUP_LAYER = 'popupLayer/OPEN'
const CLOSE_POPUP_LAYER = 'popupLayer/CLOSE'

export interface GlobalPopupLayerState {
  element: JSX.Element
  executeFunctionAtClose?: Function
  classNames?: string[]
  overElement?: {
    element: JSX.Element
    executeFunctionAtClose?: Function
    classNames?: string[]
  }
}

const initialState: GlobalPopupLayerState = {
  element: null,
  executeFunctionAtClose: null,
  classNames: null,
  overElement: {
    element: null,
    executeFunctionAtClose: null,
    classNames: null,
  },
}

export const openPopupLayer = (
  popupElement: JSX.Element,
  executeFunctionAtClose?: Function,
  classNames?: string[],
  overPopup?: boolean,
) => {
  return {
    popupElement,
    executeFunctionAtClose,
    classNames,
    overPopup,
    type: OPEN_POPUP_LAYER,
  }
}

export const closePopupLayer = () => {
  return {
    type: CLOSE_POPUP_LAYER,
  }
}

const popupLayerReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_POPUP_LAYER: {
      if (action.overPopup) {
        return {
          element: state.element,
          executeFunctionAtClose: state.executeFunctionAtClose,
          classNames: state.classNames,
          overElement: {
            element: action.popupElement,
            executeFunctionAtClose: action.executeFunctionAtClose || null,
            classNames: action.classNames,
          },
        }
      }
      return {
        element: action.popupElement,
        executeFunctionAtClose: action.executeFunctionAtClose || null,
        classNames: action.classNames,
        overElement: {
          element: null,
          executeFunctionAtClose: null,
          classNames: null,
        },
      }
    }
    case CLOSE_POPUP_LAYER: {
      if (state.overElement.element !== null) {
        return {
          element: state.element,
          executeFunctionAtClose: state.executeFunctionAtClose,
          classNames: state.classNames,
          overElement: {
            element: null,
            executeFunctionAtClose: null,
            classNames: null,
          },
        }
      }
      return {
        element: null,
        executeFunctionAtClose: null,
        overElement: {
          element: null,
          executeFunctionAtClose: null,
          classNames: null,
        },
      }
    }
    default:
      return state
  }
}

export default popupLayerReducer
